import React from "react";
import Text from "../../../../../_components/Text";
import { CreateNFeContext } from "../Context";
import LoadingInput from "../../../../../_components/LoadingInput";

export default (props) => {
  const elementRef = React.useRef(null);
  const context = React.useContext(CreateNFeContext);
  function handleChange(e){
    const {nfe} = context
    nfe.identification[e.target.name] = e.target.value
    context.handlers.updateNFeData(nfe)
  }

  if(context.step !== "finish"){
    return <span />
  }

  return (
    <div className="row" ref={elementRef}>
      <div className="col-md-6">
        <Text color="primary">Informações complementares (Opcional)</Text>
        <LoadingInput value={context.nfe.identification.additional_information} name="additional_information" onChange={handleChange} rows="3" as="textarea" />
      </div>
      <div className="col-md-6">
        <Text color="primary">Informações de FISCO</Text>
        <LoadingInput value={context.nfe.identification.fisco_information} name="fisco_information" onChange={handleChange} rows="3" as="textarea" />
      </div>
    </div>
  );

  // <CreateNFeContext>
  //     {
  //         NFeContext => {
  //             const { additional_information, fisco_information } = NFeContext["nfe"]["identification"]
  //             const { changeAdditionalInfo, changeFiscoInfo } = NFeContext["handlers"]

  //             return <div
  //                 ref={elementRef}
  //                 className={`${props.className}`}>

  //                 <div className={`${props.className} row`}>
  //                     <div className="col-12">
  //                         <Text>
  //                             {ibpt}
  //                         </Text>
  //                     </div>
  //                     <div className="col-md-6 col-xs-12 col-lg-6">
  //                         <div className="form-group">
  //                             <div className="form-label">
  //                                 <Text as="h3">
  //                                     Informações complementares (Opcional)
  //                                 </Text>
  //                             </div>
  //                             <textarea
  //                                 className="form-control"
  //                                 onChange={changeAdditionalInfo}
  //                                 value={additional_information}
  //                                 rows="4" />
  //                         </div>
  //                     </div>
  //                     <div className="col-md-6 col-xs-12 col-lg-6">
  //                         <div className="form-group">
  //                             <div className="form-label">
  //                                 <Text as="h3">
  //                                     Informações de FISCO
  //                                 </Text>
  //                             </div>
  //                             <textarea
  //                                 onChange={changeFiscoInfo}
  //                                 value={fisco_information}
  //                                 className="form-control" rows="4" />
  //                         </div>
  //                     </div>
  //                 </div>
  //             </div>

  //         }
  //     }
  // </CreateNFeContext>
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/NFeFinish/index.jsx